import { getUuid } from "../../utilities/Number";
import { isAppInViewMode } from "../../utilities/Common";
import { currentPortfolioSelector } from "../reducers/Common";

export const ENQUEUE_ITEM = "ENQUEUE_ITEM";
export const DEQUEUE_ITEM = "DEQUEUE_ITEM";
export const START_SYNC = "START_SYNC";
export const STOP_SYNC = "STOP_SYNC";
export const REMOVE_PREVIOUS_UPDATES = "REMOVE_PREVIOUS_UPDATES";
export const ADD_PENDING_DOCUMENT_UPLOAD = "ADD_PENDING_DOCUMENT_UPLOAD";
export const UPDATE_PENDING_DOCUMENT_UPLOAD = "UPDATE_PENDING_DOCUMENT_UPLOAD";
export const REMOVE_PENDING_DOCUMENT_UPLOAD = "REMOVE_PENDING_DOCUMENT_UPLOAD";
export const MARK_SYNC_QUEUE_AS_STUCK = "MARK_SYNC_QUEUE_AS_STUCK";
export const MARK_SYNC_QUEUE_AS_WAITING = "MARK_SYNC_QUEUE_AS_WAITING";

export const SyncItemType = {
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete",
  BULK_UPDATE: "bulk_update",
  DOWNLOAD: "download"
};

export class SyncItem {
  constructor(itemType, itemId, requestInstance, delay, removePreviousUpdates, onSuccess, onError) {
    this.itemType = itemType;
    this.itemId = itemId;
    this.requestInstance = requestInstance;
    this.removePreviousUpdates = removePreviousUpdates;
    this.onSuccess = onSuccess;
    this.onError = onError;
    this.onRevertLocalChange = null;
    this.onDropped = null;
    this.delay = delay;
    this.requestTimestamp = Date.now();
    this.retryCount = 0;
    this.idempotentId = getUuid();
    this.requestPayload = null;
    this.ignorable = false;
  }
}

export const enqueueItemAction = syncItem => ({
  type: ENQUEUE_ITEM,
  syncItem
});

export const dequeueItemAction = syncItem => ({
  type: DEQUEUE_ITEM,
  syncItem
});

export const startSyncAction = () => ({
  type: START_SYNC
});

export const stopSyncAction = () => ({
  type: STOP_SYNC
});

export const removePreviousUpdatesAction = itemId => ({
  type: REMOVE_PREVIOUS_UPDATES,
  itemId
});

/**
 * @param {boolean} allowWriteInReadMode | {true} when the data updates is user level and not portfolio level eg. preferences
 */
export const enqueueItem = (syncItem, allowWriteInReadMode = false, isUserAction = true) => {
  return (dispatch, getState) => {
    const currentPortfolio = currentPortfolioSelector(getState());
    if (isAppInViewMode() || (currentPortfolio && currentPortfolio.write === 0 && allowWriteInReadMode === false)) {
      return;
    }

    if (isUserAction === false) {
      syncItem.ignorable = true;
    }
    const isDeclaredAutomatic = syncItem.ignorable === true;
    if (
      syncItem.ignorable === true &&
      syncItem.removePreviousUpdates === true &&
      getState().sync.syncQueue.some(
        item => item.itemType === SyncItemType.UPDATE && item.itemId === syncItem.itemId && item.ignorable !== true
      )
    ) {
      syncItem.ignorable = false;
    }
    if (
      isDeclaredAutomatic === false &&
      process.env.REACT_APP_ENV === "local" &&
      window.navigator?.userActivation?.isActive === false
    ) {
      console.warn(
        `Sync item "${syncItem.itemId}" queued without a recent user gesture; it may be automatic, verify the caller before passing isUserAction = false`
      );
    }

    if (syncItem.removePreviousUpdates === true) {
      dispatch(removePreviousUpdatesAction(syncItem.itemId));
    }
    dispatch(enqueueItemAction(syncItem));
  };
};

export const addPendingDocumentUploadAction = document => ({
  type: ADD_PENDING_DOCUMENT_UPLOAD,
  document
});

export const updatePendingDocumentUploadAction = document => ({
  type: UPDATE_PENDING_DOCUMENT_UPLOAD,
  document
});

export const removePendingDocumentUploadAction = document => ({
  type: REMOVE_PENDING_DOCUMENT_UPLOAD,
  document
});

export const markSyncQueueAsStuckAction = () => ({
  type: MARK_SYNC_QUEUE_AS_STUCK
});

export const markSyncQueueAsWaitingAction = isWaiting => ({
  type: MARK_SYNC_QUEUE_AS_WAITING,
  isWaiting
});
